/**
 * USC Cabinet API
 * Cabinet API
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type RequestedOperationType = 'SetPasswordConfirmation' | 'SetPhoneNumberConfirmation' | 'SetEmailConfirmation';

export const RequestedOperationType = {
  SetPasswordConfirmation: 'SetPasswordConfirmation' as RequestedOperationType,
  SetPhoneNumberConfirmation: 'SetPhoneNumberConfirmation' as RequestedOperationType,
  SetEmailConfirmation: 'SetEmailConfirmation' as RequestedOperationType,
};
